import React from "react";
import { Link } from "react-router-dom";
import "./ShortIndustriesWeServe.css";

import {
  FaUniversity,
  FaHospital,
  FaBuilding,
  FaMoneyBillWave,
  FaChartLine,
  FaCogs,
  FaShoppingCart,
  FaTruck,
  FaUsers,
  FaLaptopCode,
  FaPaintBrush,
  FaFileInvoiceDollar,
} from "react-icons/fa";

const industries = [
  {
    icon: <FaFileInvoiceDollar />,
    title: "Chartered Accountants & FinTech",
    description:
      "Work management, accounting, invoicing, GST, ITR, and financial operations for CA firms.",
  },
  {
    icon: <FaUniversity />,
    title: "Education & Training",
    description:
      "Schools, colleges, coaching institutes, and online learning platforms.",
  },
  {
    icon: <FaHospital />,
    title: "Healthcare & Hospitals",
    description:
      "Hospitals, clinics, pharmacies, and wellness centers.",
  },
  {
    icon: <FaCogs />,
    title: "Industrial & Manufacturing",
    description:
      "Factories, production units, industrial automation, and IoT operations.",
  },
  {
    icon: <FaShoppingCart />,
    title: "Retail & E-commerce",
    description:
      "Online stores, supermarkets, retail chains, order & inventory management.",
  },
  {
    icon: <FaTruck />,
    title: "Logistics & Supply Chain",
    description:
      "Freight, courier, warehouse, and delivery services.",
  },
  {
    icon: <FaLaptopCode />,
    title: "Professional Services",
    description:
      "Consultants, auditors, law firms, and freelance professionals.",
  },
  {
    icon: <FaUsers />,
    title: "Hospitality & Travel",
    description:
      "Hotels, resorts, travel agencies, and event management companies.",
  },
  {
    icon: <FaBuilding />,
    title: "Real Estate & Property Management",
    description:
      "Realtors, property management firms, and construction companies.",
  },
  {
    icon: <FaChartLine />,
    title: "Finance & Investment",
    description:
      "Investment firms, wealth management, financial advisory, and stock trading.",
  },
  {
    icon: <FaPaintBrush />,
    title: "Creative & Media",
    description:
      "Photography, videography, content creation, and media agencies.",
  },
  {
    icon: <FaMoneyBillWave />,
    title: "Government & NGOs",
    description:
      "Non-profits, charities, municipal services, and community organizations.",
  },
];

export default function ShortIndustriesWeServe() {
  return (
    <section className="industries-section">
      <h2 className="industries-title">Industries We Serve</h2>
      <p className="industries-subtitle">
        Tailored work management and SaaS solutions for diverse businesses,
        enabling growth, automation, and operational efficiency.
      </p>

      <div className="industries-grid">
        {industries.map((industry, index) => (
          <div key={index} className="industry-card">
            <div className="icon-container">{industry.icon}</div>
            <h3 className="industry-title">{industry.title}</h3>
            <p className="industry-description">{industry.description}</p>
          </div>
        ))}
      </div>

      <div className="industries-cta">
        <Link to="/contact-us" className="cta-button">
          Contact Us to Get Started
        </Link>
      </div>
    </section>
  );
}
